
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150 100"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#FFF","d":"M0 0h150v100H0z"}}),_c('path',{attrs:{"fill":"#0A541B","d":"M0 0h50v100H0z"}}),_c('path',{attrs:{"fill":"#BE1E2D","d":"M100 0h50v100h-50z"}}),_c('circle',{attrs:{"fill":"#8B4F0D","cx":"75","cy":"48","r":"9"}}),_c('path',{attrs:{"d":"M86.622 57c-1.332 5.176-6.03 9-11.622 9-5.591 0-10.29-3.824-11.622-9l1.875.001A11.984 11.984 0 0075 62c4.015 0 7.569-1.971 9.747-4.999h1.875z","fill":"#0A541B"}})])])
          )
        }
      }
    